import React, { useContext } from 'react';
import Digit from './Digit';
import './App.css';
import { ClockContext } from './ClockContext';

const App = () => {

  const { time, color, setColor, disco, setDisco } = useContext(ClockContext);

  // Helper to format numbers
  const format = ( num ) => String(num).padStart(2, '0');

  return (
    <>
      <div className="clock">
        <Digit value={format(time.getHours())}/>
        <Digit value={format(time.getMinutes())}/>
        <Digit value={format(time.getSeconds())}/>
      </div>
      <div className="settings">
        <h2>Settings</h2>
        <div className="setting">
          <label htmlFor="activeColor">Active cell colour</label>
          <input type="color" id="activeColor" value={color} onChange={( e ) => setColor(e.target.value)}/>
        </div>
        <div className="setting">
          <label htmlFor="discoFloor">Disco floor?</label>
          <input type="checkbox" id="discoFloor" checked={disco} onChange={( e ) => setDisco(e.target.checked)}/>
        </div>
      </div>
    </>
  );
};

export default App;